import { ForwardedRef, forwardRef, ReactElement, Ref } from 'react';
import { CoreSelect, CoreSelectProps } from '../_core';
import { clsx } from '../../utils';
import { defaultSelectInputStyles, defaultSelectItemStyles, defaultSelectMenuStyles } from './input.styles';

export const SelectBase = <Value = unknown>(
	{ sx, MenuProps, ...props }: CoreSelectProps<Value>,
	ref: ForwardedRef<HTMLElement>
): ReactElement => (
	<CoreSelect
		{...props}
		sx={clsx(defaultSelectInputStyles(), sx)}
		MenuItemProps={{
			...props.MenuItemProps,
			sx: clsx(defaultSelectItemStyles(), props.MenuItemProps?.sx),
		}}
		MenuProps={{
			...(MenuProps ?? {}),
			PaperProps: {
				...(MenuProps?.PaperProps ?? {}),
				sx: clsx(defaultSelectMenuStyles(), MenuProps?.PaperProps?.sx),
			}
		}}
		ref={ref}
	/>
);

export const Select = forwardRef(SelectBase) as <T>(
	props: CoreSelectProps<T> & { ref?: Ref<HTMLElement>}
) => ReturnType<typeof SelectBase>;
